<template>
  <div id="contenedor-nueva-observacion-comentario">
    <v-form
      v-model="formularioValido"
      ref="editarAuditoriaInformeObservacion">
      <v-card>
        <v-card-title>
          Comentario Observación
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
            <v-row>
            <v-col>
                <v-row>
                <v-col cols="3">
                    Observación:
                </v-col>
                <v-col cols="9">
                    <span
                    class="font-weight-bold azul2--text"
                    style="padding-left: 10px; display: block;"
                    v-if="observacion.numero">
                    {{observacion.numero}}</span>
                </v-col>
                </v-row>
                <div>
                    <span
                    class="text-caption font-weight-light"
                    style="padding-left: 10px; display: block;"
                    v-if="observacion.descripcion">
                    <cortar-texto
                    :texto="observacion.descripcion ?
                    observacion.descripcion : ''"
                    >
                    </cortar-texto>
                    </span>
                </div>
            </v-col>
            </v-row>
        </v-card-subtitle>
        <v-card-text>
            <v-row>
            <v-col cols="12" md="12">
              <TextArea
                v-model="observacion.comentarios"
                label="Comentarios"
                rows="10">
              </TextArea>
            </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixObservaciones from './mixObservaciones';

export default {
  name: 'RegistrarNuevaObservacionComentario',
  mixins: [mixObservaciones],
  props: {
    observacionEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextArea,
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      observacionIdContrato: this.observacionEditar.idContrato,
      observacion: {
        numero: this.observacionEditar.numero,
        descripcion: this.observacionEditar.descripcion,
        medidaSolventacion: this.observacionEditar.medidaSolventacion,
        montoOriginal: this.observacionEditar.montoOriginal,
        montoPendiente: this.observacionEditar.montoPendiente,
        estatus: this.observacionEditar.estatus,
        fechaEstatus: new Date(`${this.observacionEditar.fechaEstatus} 00:00:0`),
        comentarios: this.observacionEditar.comentarios,
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixActualizarObservacionSoloComentario();
    },
    limpiarFormularioObservacion() {
      this.$refs.editarAuditoriaInformeObservacion.reset();
    },
    cerrar() {
      this.limpiarFormularioObservacion();
      this.$emit('cerrar');
    },
  },
};
</script>
